(() => {
  if (customElements.get('wf-header-contact')) return;

  class HeaderContact extends HTMLElement {
    #controller;
    #details;
    #trigger;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      this.#details = this.querySelector('details');
      this.#trigger = this.querySelector('summary');
      if (!this.#details || !this.#trigger) return;

      const options = { signal: this.#controller.signal };

      this.#trigger.addEventListener('pointerdown', () => {
        this.#details.removeAttribute('data-instant');
      }, options);

      this.#trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.#details.setAttribute('data-instant', '');
        }
      }, options);

      // Native details supplies the expanded state and works without JavaScript.
      document.addEventListener('click', (event) => {
        if (event.target instanceof Node && !this.contains(event.target)) this.#close();
      }, { ...options, capture: true });

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.#details.open) return;
        event.preventDefault();
        event.stopPropagation();
        this.#details.setAttribute('data-instant', '');
        this.#close(true);
      }, options);

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.#close();
      }, options);

      this.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.#close(true), options);
      });

      // Close when switching between the compact and full header layouts.
      window.matchMedia('(min-width: 990px)').addEventListener('change', () => {
        this.#close();
      }, options);
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #close(restoreFocus = false) {
      if (!this.#details?.open) return;
      this.#details.open = false;
      if (restoreFocus) this.#trigger.focus();
    }
  }

  customElements.define('wf-header-contact', HeaderContact);
})();
